import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'

import Page from 'Containers/Page'

import { EmptyState, ToastContainer } from 'mailup-web-components'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import ClickTable from './ClickTable'
import Header from './Header'
import { resultsStateEmptyState } from './recoil/state/result'

import {
  getRecipientCallback,
  resetPageCallback,
} from './recoil/callbacks/callbacks'

const ProfileClick = () => {
  const intl = useIntl()

  const isEmptyState = useRecoilValue(resultsStateEmptyState)
  const { idRecipient } = useParams()
  const getRecipient = useRecoilCallback(getRecipientCallback, [])

  const resetPage = useRecoilCallback(resetPageCallback, [])

  const initPage = () => {
    getRecipient(idRecipient)
  }

  useEffect(() => {
    initPage()
    // laodClickTable({ idRecipient })

    return () => {
      resetPage()
    }
  }, [])

  return (
    <>
      <Header />
      <ToastContainer />
      <Page onReload={initPage}>
        {isEmptyState ? (
          <EmptyState
            title={intl.formatMessage({
              id: 'Load.EmailMessageList.EmptyStateActiveRecipientClickDetailsTitle',
            })}
            description={intl.formatMessage({
              id: 'Load.EmailMessageList.EmptyStateActiveRecipientClickDetailsDescription',
            })}
          />
        ) : (
          <ClickTable />
        )}
      </Page>
    </>
  )
}

export default ProfileClick
